export default __webpack_public_path__ + "static/media/flags.0e0e67b2.png";